<template>
  <div class="ag-studio-tab ag-settings ag-studio-embed ag-studio-embed--settings">
    <SnackbarComp :SnackbarComponent="snackbar" />

    <OtherSettingsTab
      ref="settingsTabRef"
      :active="active"
      embedded
      @snackbar="onSnackbar"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import SnackbarComp from '@/components/Extras/SnackbarComp.vue'
import OtherSettingsTab from '@/components/Organizations/Tabs/OtherSettingsTab.vue'

defineOptions({ name: 'AgentSettingsStudio' })

defineProps({
  active: { type: Boolean, default: false },
})

const snackbar = ref({})

function onSnackbar({ color, text }) {
  snackbar.value = {
    SnackbarVmodel: true,
    SnackbarColor: color,
    SnackbarText: text,
  }
}
</script>
